import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Card, Divider } from "antd";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { initiateForgotPassword } from "../../actions/auth/forgotPassword";
import Swal from "sweetalert2";

const { Option } = Select;

function ForgotPassword(props) {
  const [nationalIdentifier, setNationalIdentifier] = useState();
  const [identityType, setIdentityType] = useState("tckn");
  const [showIdentity, setShowIdentity] = useState(false);
  const [identityNumber, setIdentityNumber] = useState(null);
  const [pasaportNumber, setPasaportNumber] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    try {
      await localStorage.setItem("nationalIdentifier", nationalIdentifier);
      dispatch(initiateForgotPassword(nationalIdentifier));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (props.forgotPassword.done) {
      navigate("/forgot-password-verify");
    } else if (
      props.forgotPassword.error &&
      props.forgotPassword.error.response?.status === 428
    ) {
      setShowIdentity(true);
    } else if (
      props.forgotPassword.error &&
      props.forgotPassword.error.response?.status === 409
    ) {
      navigate("/forgot-password-verify"); // 409 durumunda yönlendir
    } else if (
      props.forgotPassword.error &&
      props.forgotPassword.error.response?.status === 429
    ) {
      Swal.fire({
        icon: "error",
        title: "Erişim Kısıtlandı",
        text: "Yaptığınız işlemler sunucularımıza olağandışı bir yük oluşturduğundan, erişiminizi kısıtladık. Bu durum, hesabınızın güvenliği veya sistemimizin düzgün çalışması için alınan bir önlemdir. Lütfen destek ekibimizle iletişime geçin. Anlayışınız için teşekkür ederiz!",
        footer: `
          <div>
            <a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>
            <br>
            <a href="tel:+903129060708">📞 +90 (312) 906 07 08</a>
            <br>
            <a href="tel:+908504500606">📞 0 (850) 450 06 06</a>
          </div>
        `,
      });
    } else if (props.forgotPassword.error.response?.data?.responseMessage) {
      Swal.fire({
        icon: "error",
        title: props?.forgotPassword?.error?.response?.data?.responseMessage,
        footer: `
          <div>
            <a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>
            <br>
            <a href="tel:+903129060708">📞 +90 (312) 906 07 08</a>
            <br>
            <a href="tel:+908504500606">📞 0 (850) 450 06 06</a>
          </div>
        `,
      });
    }
  }, [props.forgotPassword, navigate]);


  return (
    <div className="flex justify-center items-center max-h-screen md:h-screen bg-gray-100">
      <Card
        className="shadow-xl p-4 w-full max-w-full md:max-w-[600px] h-screen md:h-[300px] "
      >
        <div className="text-center mb-4">
          <div className="flex justify-between">
            <div>
              <h2 className="block text-lg font-bold text-gray-800 mb-5">
                Şifremi Unuttum
              </h2>
            </div>
            <div className="w-14">
              <img
                src="https://www.onedose.io/wp-content/uploads/2020/09/onedose_black.png"
                alt="logo"
              />
            </div>
          </div>
          <p className="text-sm text-gray-600">
            Mevcut bir hesabınız varsa{" "}
            <Link to="/login" className="text-blue-500">
              buradan giriş yapın
            </Link>
          </p>
        </div>
        <Divider />
        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label="Kimlik Numarası"
            name="nationalIdentifier"
            rules={[{ required: true, message: "Kimlik Numarası zorunludur!" }]}
          >
            <Input
              value={nationalIdentifier}
              onChange={(e) => setNationalIdentifier(e.target.value)}
              inputStyle={{
                width: "100%",
                borderRadius: 4,
                border: "1px solid #d9d9d9",
              }}
              placeholder="Kimlik numaranızı girin"
            />
          </Form.Item>
          {showIdentity && (
            <>
              <Form.Item
                label="Doğrulama Türü"
                name="identityType"
                rules={[
                  { required: true, message: "Doğrulama türü seçilmelidir!" },
                ]}
              >
                <Select
                  value={identityType}
                  onChange={(value) => setIdentityType(value)}
                  placeholder="Lütfen seçiniz"
                >
                  <Option value="tckn">T.C Kimlik Numarası</Option>
                  <Option value="pasaport">Pasaport Numarası</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label={
                  identityType === "tckn"
                    ? "T.C Kimlik Numarası"
                    : "Pasaport Numarası"
                }
                name="identityValue"
                rules={[
                  {
                    required: true,
                    message: `${identityType === "tckn"
                      ? "T.C Kimlik Numarası"
                      : "Pasaport Numarası"
                      } zorunludur!`,
                  },
                ]}
              >
                <Input
                  placeholder={`${identityType === "tckn"
                    ? "T.C Kimlik Numarası"
                    : "Pasaport Numarası"
                    } giriniz`}
                  value={
                    identityType === "tckn" ? identityNumber : pasaportNumber
                  }
                  onChange={(e) =>
                    identityType === "tckn"
                      ? setIdentityNumber(e.target.value)
                      : setPasaportNumber(e.target.value)
                  }
                />
              </Form.Item>
            </>
          )}
          <Form.Item>
            {props.forgotPassword.spinner ? (
              <Button type="primary" size="large" loading className="w-full">
                İşlem devam ediyor
              </Button>
            ) : (
              <Button type="primary" size="large" htmlType="submit" className="w-full" disabled={!nationalIdentifier}>
                Devam Et
              </Button>
            )}
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    forgotPassword: state.forgotPassword,
  };
};

export default connect(mapStateToProps)(ForgotPassword);
